import "./App.scss";
import Notification from "./Notification/Notification";

const App = () => {
  return <Notification />;
};

export default App;
